module.exports = __webpack_public_path__ + "img/chapter-1-thumb.60cba8d6.jpg";